import * as React from "react";

import {
    Edit,
    SimpleForm,
    TextInput, 
    useNotify,
    useRefresh,
    useRedirect,
} from "react-admin";





const validateOperationUpdate = (values) => {
    const errors = {};
    if (values.password !== values.confirmPassword) {
        errors.password = "Passwords do not match";
        errors.confirmPassword = "Passwords do not match";
    }

    return errors;
};




export const OperationEdit = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();

    const onSuccess = (data) => {
        notify(`Changes saved`);
        redirect("/operations");
        refresh();
    };

    const onFailure = (error) => {
        notify(`Could not edit operation: ${error.message}`);
        refresh();
    };

    return (
        <Edit mutationMode="pessimistic" undoable={false} onSuccess={onSuccess} onFailure={onFailure} {...props}>
            <SimpleForm validate={validateOperationUpdate}>
                <>
                    <div className="operation_feild">
                        <h2>Edit operation</h2>
                        <div className="operations_data"></div>
                        <TextInput source="zipcode" />
                        <TextInput source="radius" />
                    </div>
                </>
            </SimpleForm>
        </Edit>
    );
};